import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Divider
} from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CancelIcon from '@mui/icons-material/Cancel';

const ValidationErrorDialog = ({ open, message, onClose, title, onConfirm, onCancel }) => {
  const handleClose = onCancel || onClose;
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="xs"
      PaperProps={{
        elevation: 0,
        sx: {
          borderRadius: 1,
          minWidth: '380px',
          maxWidth: '380px !important',
          overflow: 'hidden',
          boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
          '.MuiDialogContent-root': {
            padding: 0
          }
        }
      }}
    >
      <Box sx={{
        bgcolor: '#FEF2F2',
        borderBottom: '1px solid #FEE2E2',
        p: 2,
        display: 'flex',
        alignItems: 'center',
        gap: 1.5
      }}>
        <CancelIcon sx={{ 
          color: '#DC2626',
          fontSize: '22px'
        }} />
        <Typography sx={{ 
          fontSize: '0.9375rem',
          fontWeight: 600,
          color: '#991B1B',
          letterSpacing: '-0.01em'
        }}>
          {title || 'Validation Error'}
        </Typography>
      </Box>

      <DialogContent>
        <Box sx={{ 
          p: 2.5,
          pb: 2,
          color: '#1F2937'
        }}>
          <Typography sx={{ 
            fontSize: '0.875rem',
            lineHeight: 1.5,
            color: 'inherit'
          }}>
            {message}
          </Typography>
        </Box>
      </DialogContent>

      <Divider sx={{ borderColor: '#E5E7EB' }} />

      <DialogActions sx={{ 
        p: 1.5,
        bgcolor: '#F9FAFB',
        justifyContent: 'flex-end',
        gap: 1
      }}>
        <Button
          onClick={handleClose}
          disableElevation
          variant={onConfirm ? "outlined" : "contained"}
          size="small"
          sx={{
            ...(onConfirm ? {
              color: '#374151',
              borderColor: '#D1D5DB',
              px: 2,
              py: 0.75,
              fontSize: '0.8125rem',
              fontWeight: 500,
              borderRadius: 1,
              textTransform: 'none',
              '&:hover': {
                bgcolor: '#F3F4F6',
                borderColor: '#D1D5DB'
              }
            } : {
              bgcolor: '#DC2626',
              fontSize: '0.8125rem',
              fontWeight: 500,
              px: 2,
              py: 0.75,
              borderRadius: 1,
              textTransform: 'none',
              '&:hover': {
                bgcolor: '#B91C1C'
              }
            })
          }}
        >
          Close
        </Button>
        {onConfirm && (
          <Button
            onClick={onConfirm}
            disableElevation
            variant="contained"
            size="small"
            sx={{
              bgcolor: '#DC2626',
              fontSize: '0.8125rem',
              fontWeight: 500,
              px: 2,
              py: 0.75,
              borderRadius: 1,
              textTransform: 'none',
              '&:hover': {
                bgcolor: '#B91C1C'
              }
            }}
          >
            Delete
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ValidationErrorDialog;
